import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/500px': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M103.3 344.3c-6.5-14.2-6.9-18.3 7.4-23.1 25.6-8 8 9.2 43.2 49.2h0.3v-93.9c1.2-50.2 44-92.2 97.7-92.2 53.9 0 97.7 43.5 97.7 96.8 0 63.4-60.8 113.2-128.5 93.3-10.5-4.2-2.1-31.7 8.5-28.6 53 0 89.4-10.1 89.4-64.4 0-61-77.1-89.6-116.9-44.6-23.5 26.4-17.6 42.1-17.6 157.6 50.7 31 118.3 22 160.4-20.1 24.8-24.8 38.5-58 38.5-93 0-35.2-13.8-68.2-38.8-93.3-24.8-24.8-57.8-38.5-93.3-38.5s-68.8 13.8-93.5 38.5c-0.3 0.3-16 16.5-21.2 23.9l-0.5 0.6c-3.3 4.7-6.3 9.1-20.1 6.1-6.9-1.7-14.3-5.8-14.3-11.8v-186.8c0-5 3.9-10.5 10.5-10.5h241.3c8.3 0 8.3 11.6 8.3 15.1 0 3.9 0 15.1-8.3 15.1h-223.2v132.9h0.3c104.2-109.8 282.8-36 282.8 108.9 0 178.1-244.8 220.3-310.1 62.8zM166.6 83.5c3.8-18.8 145.1-50.8 238.3 38.2 8.5 7.5-9.5 22.8-14.3 22.8-6.6 0-84.6-87.9-209.4-40.4-10 3.9-15.1-16.4-14.6-20.6zM393 414.7c8.1-8 27.6 12.6 20.7 20.4-135.6 135.6-357.6 52.1-381.6-121.3-1.5-10.7 28.9-15.5 28.9-3.3 33 165 222 214.1 332 104.2zM213.6 306.6c0-3.4 2.3-4.7 20.4-22.6l-18.2-18.2c-5.6-5.6 7.4-17.3 12.4-17.3 3.1 0 2.9 0.7 21.5 19.5l17.9-17.9c6.1-6.1 22.5 8.9 16.2 15.7l-18.2 18.2 17.3 17.3c7.8 7.8-5.3 18.2-10.7 18.2-3.2 0-2.7-0.2-22.3-19.5-19.7 19.7-18.5 19.5-22.3 19.5-2.4 0-5.5-1.4-8.5-4.4-1.2-1.2-5.5-4.5-5.5-8.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/500px.js
// module id = 689
// module chunks = 0